function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { j as e } from "./index.es33.js";
import { clsx as h } from "./index.es105.js";
import { Typography as x } from "./index.es35.js";
import "./index.es36.js";
import { InputHint as M } from "./index.es108.js";
import { inputSelectors as T } from "./index.es107.js";
import { DatePicker as _ } from "./index.es81.js";
import { CalendarIcon as z } from "./index.es642.js";
import { InputPickerSize as w, CalendarPosition as G } from "./index.es434.js";
import { useSingleState as H } from "./index.es654.js";
import { useSingleRef as O } from "./index.es655.js";
import { useChangeInput as q } from "./index.es656.js";
import { usePlaceholder as L } from "./index.es657.js";
import { useClosePopup as J } from "./index.es658.js";
import { PickerWrapper as Q } from "./index.es651.js";
import { getNormalizedDate as U } from "./index.es643.js";
import { getPopupPosition as X } from "./index.es644.js";
import { preserveTimeDateSingleSelect as Y } from "./index.es645.js";
import { DATE_MASK_SINGLE_REG as Z } from "./index.es652.js";
import a from "./index.es111.js";
import n from "./index.es653.js";
import m from "./index.es659.js";

var ye = function ye(_ref) {
  var _h;

  var B = _ref.label,
      D = _ref.placeholder,
      c = _ref.isError,
      S = _ref.hint,
      I = _ref.isDateDisabled,
      t = _ref.date,
      C = _ref.onSelect,
      g = _ref.isClearable,
      u = _ref.isDisabled,
      _ref$size = _ref.size,
      j = _ref$size === void 0 ? w.default : _ref$size,
      _ref$calendarPosition = _ref.calendarPosition,
      F = _ref$calendarPosition === void 0 ? G.default : _ref$calendarPosition;

  var _O = O(),
      p = _O.inputRef,
      y = _O.wrapperRef,
      _H = H(t, p),
      r = _H.inputValue,
      v = _H.setInputValue,
      l = _H.isFocused,
      i = _H.setIsFocused,
      s = _H.isOpen,
      d = _H.setIsOpen,
      f = function f(o) {
    Y(t, C)(o), requestAnimationFrame(function () {
      return i(!1);
    });
  },
      R = X(F, j, !!(S !== null && S !== void 0 && S.length)),
      W = q({
    inputValue: r,
    setInputValue: v,
    inputRef: p
  }),
      k = function k() {
    t && g ? f === null || f === void 0 ? void 0 : f(void 0) : (i(!l), d(!s));
  },
      N = L({
    isFocused: l,
    isOpen: s,
    inputValue: r,
    placeholder: D
  }),
      _J = J({
    inputRef: p,
    setIsOpen: d,
    wrapperRef: y
  }),
      V = _J.onBlur,
      b = _J.onWrapperKeyDown,
      A = function A() {
    if (i(!1), d(!1), !r) return;
    var o = U(r),
        E = I === null || I === void 0 ? void 0 : I(o),
        K = !Z.test(r),
        P = E || K;
    P && v(""), f(P ? void 0 : o);
  };

  return e.jsxs("div", {
    ref: y,
    className: n.wrapper,
    onBlur: V,
    onKeyDown: b,
    children: [e.jsxs(Q, {
      label: B,
      isDisabled: u,
      isError: c,
      children: [e.jsxs("div", {
        className: h(a.wrapper, n.inputInner, T.classNames.wrapper, (_h = {}, _defineProperty(_h, a.largeSizeWrapper, j === w.large), _defineProperty(_h, a.wrapperWithError, c), _defineProperty(_h, n.inputInnerFocused, l || s), _defineProperty(_h, n.inputInnerWithValue, !!t), _h)),
        children: [(l || s) && e.jsxs("div", {
          className: m.placeholder,
          style: {
            left: "12px"
          },
          children: [e.jsx(x.Body2, {
            className: h(m.placeholderItem, m.placeholderHidden),
            children: r
          }), e.jsx(x.Body2, {
            className: m.placeholderItem,
            children: N
          })]
        }), e.jsx(x.Body2, {
          className: a.input,
          as: "input",
          disabled: u,
          ref: p,
          type: "text",
          value: r,
          placeholder: N,
          onChange: function onChange(o) {
            return W(o.target.value);
          },
          onFocus: function onFocus() {
            return i(!0);
          },
          onBlur: A
        }), e.jsx("button", {
          className: n.button,
          disabled: u,
          type: "button",
          onClick: k,
          onMouseDown: function onMouseDown(o) {
            return o.preventDefault();
          },
          children: e.jsx(z, {
            value: t,
            isClearable: g
          })
        })]
      }), e.jsx(M, {
        isError: c,
        hint: S
      })]
    }), s && e.jsx("div", {
      className: h(n.datePickerWrapper, R),
      onMouseDown: function onMouseDown(o) {
        return o.preventDefault();
      },
      children: e.jsx(_, {
        isDateDisabled: I,
        date: t,
        onSelect: f
      })
    })]
  });
};

export { ye as Single };